import {useSelector} from 'react-redux';

import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import {
    getEngagementLeadCounts,
    getListIsLoading,
    getListIsFirstLoad,
} from '../../reports/engagement/leads/leads-selectors';

import {ENGAGEMENT_LEAD_TYPES} from '../consts';

import {EngagementLeadBannerItem} from './engagement-lead-banner-item';

import styles from './engagement-leads-banner.module.css';

export function EngagementLeadsBanner() {
    const counts = useSelector(getEngagementLeadCounts);
    const isLoading = useSelector(getListIsLoading);
    const isFirstLoad = useSelector(getListIsFirstLoad);

    return (
        <div className='flex px-32 py-12 bg-white border-bottom'>
            <div className={styles.container}>
                {isFirstLoad || isLoading
                    ? ENGAGEMENT_LEAD_TYPES.map((type) => (
                          <Stack key={type} isHorizontal={true} spacing={8} alignItems='center'>
                              <LoadingText width={24} height={20} />
                              <LoadingText width={80} height={16} />
                          </Stack>
                      ))
                    : ENGAGEMENT_LEAD_TYPES.map((type) => (
                          <EngagementLeadBannerItem key={type} type={type} count={counts[type]} />
                      ))}
            </div>
        </div>
    );
}
